export class TableFilter {
  entries?: number
  fromDate?: string // format: "YYYY-MM-DD"
  toDate?: string // format: "YYYY-MM-DD"
  showSignal?: boolean = false;  // Signal Status hide/show
  showDLM?: boolean = false;// DLM-Status hide/show
  filterSignal?: boolean = false;
  filterDLM?: boolean = false;
}
